import type { Resource } from 'i18next'

import * as deDE from './de-DE'
import * as enGB from './en-GB'
import * as fiFI from './fi-FI'
import * as nbNO from './nb-NO'
import * as nlNL from './nl-NL'
import * as plPL from './pl-PL'
import * as svSE from './sv-SE'

export const SUPPORTED_LANGUAGES = ['en-GB', 'fi-FI', 'de-DE', 'nl-NL', 'nb-NO', 'sv-SE', 'pl-PL'] as const
export type SupportedLanguage = (typeof SUPPORTED_LANGUAGES)[number]

export const DEFAULT_LANGUAGE: SupportedLanguage = 'en-GB'

export const LANGUAGE_LABELS: Record<SupportedLanguage, string> = {
	'en-GB': 'English',
	'fi-FI': 'Suomi',
	'de-DE': 'Deutsch',
	'nl-NL': 'Nederlands',
	'nb-NO': 'Norsk',
	'sv-SE': 'Svenska',
	'pl-PL': 'Polski',
}

export const resources: Resource = {
	'en-GB': {
		analytics: enGB.analytics,
		auth: enGB.auth,
		common: enGB.common,
		editor: enGB.editor,
		start: enGB.start,
	},
	'fi-FI': {
		analytics: fiFI.analytics,
		auth: fiFI.auth,
		common: fiFI.common,
		editor: fiFI.editor,
		start: fiFI.start,
	},
	'de-DE': {
		analytics: deDE.analytics,
		auth: deDE.auth,
		common: deDE.common,
		editor: deDE.editor,
		start: deDE.start,
	},
	'nl-NL': {
		analytics: nlNL.analytics,
		auth: nlNL.auth,
		common: nlNL.common,
		editor: nlNL.editor,
		start: nlNL.start,
	},
	'nb-NO': {
		analytics: nbNO.analytics,
		auth: nbNO.auth,
		common: nbNO.common,
		editor: nbNO.editor,
		start: nbNO.start,
	},
	'sv-SE': {
		analytics: svSE.analytics,
		auth: svSE.auth,
		common: svSE.common,
		editor: svSE.editor,
		start: svSE.start,
	},
	'pl-PL': {
		analytics: plPL.analytics,
		auth: plPL.auth,
		common: plPL.common,
		editor: plPL.editor,
		start: plPL.start,
	},
}
